@if (open) {
<div class="modal-backdrop fade show"></div>
<div class="modal fade show detail-modal" tabindex="-1" aria-modal="true" role="dialog">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        @if (isCreateMode()) {
        <h2 class="modal-title">{{ 'pages.profiles.modal.create-title' | translate }}</h2>
        } @else {
        <h2 class="modal-title">{{ 'pages.profiles.modal.edit-title' | translate }}</h2>
        }

        <button class="btn-close" type="button" (click)="closeDetailModal()"></button>
      </div>

      <form class="modal-body form-grid" [formGroup]="form" (ngSubmit)="save()">
        <div class="field-block">
          <label class="form-label" for="profile-application">{{ 'pages.profiles.fields.application' | translate
            }}</label>
          <select class="form-select" [disabled]="saving() || deleting()" id="profile-application"
            [value]="selectedApplicationId() ?? ''" (change)="onApplicationSelectionChange($event)">
            <option value="">{{ 'pages.profiles.applications.select-placeholder' | translate }}</option>
            @for (application of availableApplications(); track application.id ?? application.code) {
            <option [value]="application.id ?? ''" [selected]="application.id === selectedApplicationId()">{{ application.name }}</option>
            }
          </select>
        </div>

        <app-input-block [invalid]="isInvalid('name')" controlId="profile-name" controlName="name"
          labelKey="pages.profiles.fields.name">
          @if (hasError('name', 'required') && isInvalid('name')) {
          <div class="invalid-feedback">{{ 'pages.profiles.validation.name-required' | translate }}</div>
          }
          @if (hasError('name', 'maxlength') && isInvalid('name')) {
          <div class="invalid-feedback">{{ 'pages.profiles.validation.name-maxlength' | translate }}</div>
          }
        </app-input-block>

        <app-input-block [fullWidth]="true" [invalid]="isInvalid('description')" controlId="profile-description"
          controlName="description" labelKey="pages.profiles.fields.description">
          @if (hasError('description', 'required') && isInvalid('description')) {
          <div class="invalid-feedback">{{ 'pages.profiles.validation.description-required' | translate }}</div>
          }
          @if (hasError('description', 'maxlength') && isInvalid('description')) {
          <div class="invalid-feedback">{{ 'pages.profiles.validation.description-maxlength' | translate }}</div>
          }
        </app-input-block>

        <div class="field-block field-block-full">
          <label class="form-label" for="profile-role">{{ 'pages.profiles.fields.roles' | translate }}</label>
          <div class="input-group">
            <select class="form-select" [disabled]="saving() || deleting() || selectedApplicationId() === null"
              id="profile-role" [value]="selectedRoleId() ?? ''" (change)="onRoleSelectionChange($event)">
              <option value="">{{ 'pages.profiles.roles.select-placeholder' | translate }}</option>
              @for (role of selectableRoles(); track role.id ?? role.code) {
              <option [value]="role.id ?? ''">{{ role.description }}</option>
              }
            </select>
            <button class="btn btn-secondary" [disabled]="selectedRoleId() === null || saving() || deleting()" type="button"
              (click)="addSelectedRole()">
              <i class="fa-solid fa-plus" aria-hidden="true"></i>
              {{ 'pages.profiles.roles.add' | translate }}
            </button>
          </div>
          <div class="d-flex flex-wrap gap-2 mt-2">
            <button class="btn btn-secondary btn-sm" [disabled]="saving() || deleting() || selectedApplicationId() === null"
              type="button" (click)="selectAllRoles()">
              <i class="fa-regular fa-square-check" aria-hidden="true"></i>
              {{ 'pages.profiles.roles.select-all' | translate }}
            </button>
            <button class="btn btn-secondary btn-sm" [disabled]="saving() || deleting() || roles().length === 0"
              type="button" (click)="unselectAllRoles()">
              <i class="fa-regular fa-square-minus" aria-hidden="true"></i>
              {{ 'pages.profiles.roles.unselect-all' | translate }}
            </button>
          </div>
          @if (roles().length === 0) {
          <div class="relations-empty mt-2">{{ 'pages.profiles.roles.empty' | translate }}</div>
          } @else {
          <ul class="relations-list mt-2">
            @for (role of roles(); track role.id ?? role.code) {
            <li class="relation-item">
              <span class="relation-label">{{ role.description }}</span>
              @if (role.id !== null) {
              <button class="btn btn-light btn-sm" [disabled]="saving() || deleting()" type="button"
                (click)="removeRole(role.id)">
                <i class="fa-solid fa-xmark" aria-hidden="true"></i>
                {{ 'pages.profiles.roles.remove' | translate }}
              </button>
              }
            </li>
            }
          </ul>
          }
        </div>

        @if (isEditMode()) {
        <app-input-block [readonly]="true" [value]="selectedCreatedAt()" controlId="created-at"
          labelKey="pages.profiles.fields.created-at" />

        <app-input-block [readonly]="true" [value]="selectedUpdatedAt()" controlId="updated-at"
          labelKey="pages.profiles.fields.updated-at" />
        }
      </form>

      <div class="modal-footer">
        @if (isEditMode()) {
        <button class="btn btn-light btn-danger-soft me-auto" [disabled]="saving() || deleting()" type="button"
          (click)="requestDelete()">
          <i class="fa-solid fa-trash" aria-hidden="true"></i>
          {{ 'pages.profiles.actions.delete' | translate }}
        </button>
        }

        <button class="btn btn-light" [disabled]="saving() || deleting()" type="button" (click)="closeDetailModal()">
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
          {{ 'pages.profiles.actions.cancel' | translate }}
        </button>

        <button class="btn btn-primary" [disabled]="saving() || deleting()" type="button" (click)="save()">
          <i class="fa-solid fa-floppy-disk" aria-hidden="true"></i>
          {{ 'pages.profiles.actions.save' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
}